export function objectValueSort<T>(func: (item: T) => unknown) {
  return (a: T, b: T) => {
    const aVal = func(a)
    const bVal = func(b)
    if (typeof aVal === 'string' && typeof bVal === 'string') {
      return aVal.localeCompare(bVal)
    }
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return bVal - aVal
    }
    return 0
  }
}

export function getSortedByValue<T>(
  items: T[],
  [groupKey, sortKey]: [string, string],
): { [key: string]: T[] } {
  const grouped = items.reduce((acc: { [id: string]: T[] }, item) => {
    const key = (item as Record<string, unknown>)[groupKey] as string
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(item)
    return acc
  }, {})
  return Object.keys(grouped).reduce((acc: { [id: string]: T[] }, id) => {
    acc[id] = grouped[id].sort((b, a) =>
      String((a as Record<string, unknown>)[sortKey]).localeCompare(
        String((b as Record<string, unknown>)[sortKey]),
      ),
    )
    return acc
  }, {})
}

export function objectFieldSort<TObj, TProp extends keyof TObj>(
  ...fields: TProp[]
) {
  return (a: TObj, b: TObj) => {
    for (const field of fields) {
      const av = a[field]
      const bv = b[field]

      if (av === bv) continue
      return av < bv ? -1 : 1
    }
    return 0
  }
}
